import { config } from '@/pageConfig/policyTwo/us/en';
import { PolicyTwoPageTemplate } from '@/pageTemplate/PolicyTwoPageTemplate';
import { useAnalyticsContext } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';

export default function RentersPage() {
  const { trackEvent } = useAnalyticsContext();
  useEffect(() => trackEvent('policy-two_page.viewed', { variant: 'default', lang: 'en-US' }), [trackEvent]);

  return <PolicyTwoPageTemplate config={config} locale="en-US" />;
}
